import React from "react";
import "./AboutUs.css";
import Pictures from "../../Pic";
import { Helmet } from "react-helmet";

function AboutUs() {
  return (
    <>
      <Helmet>
        <title>Creative Balloons, All Inflatables | About Us</title>
        <meta
          name="description"
          content="Creative Balloons is a trusted manufacturer and supplier of
          premium quality Inflatable Characters, Advertising Balloons, and
          other products."
        />
      </Helmet>
      <section className="aboutUs" id="ABOUT">
        <div className="aboutInnerSec">
          <div className="heroBanner">
            <img src={Pictures.AboutUs.img1} className="logo" alt="" />
            <div className="supportingPan">
              <span className="imgTxt1">About </span>
              <span className="imgTxt2">Creative Balloons</span>
            </div>
          </div>
          <div className="inner-Sec1">
            <p className="para">
              Creative Balloons is a trusted manufacturer and supplier of
              premium quality Inflatable Characters, Advertising Balloons, and
              other products. We have been in business since 2011, and our
              extensive range of products includes Advertising Air Dancers, Hot
              Air Shape Sky Balloons, Airship Sky Balloons, Back Pack Balloons,
              Android Walking Balloons, and Hanuman Ji Walking Inflatables, as
              well as Inflatable Arches, Inflatable Slide Bouncies, VIP Pizza
              Rubber Balloons, ACC Pole Balloons, Hanging Balloons, Walking
              Inflatables, Sky Balloon Manufacturers in Hyderabad, Advertising
              Balloon Manufacturers in Hyderabad, Inflatable Transparent Balls,
              and many more.
            </p>
            <p className="para">
              Our company utilizes the latest technology and machinery to
              manufacture products of the highest quality that adhere to
              international standards. Our products are resistant to tearing,
              and tampering, and are effortless to inflate due to our advanced
              inflation technology. Additionally, we offer customized products
              to meet specific client requirements. These products feature
              finely printed logos, names, or other promotional content that
              represents the company. Before dispatching, we guarantee a
              thorough examination of these products based on specific criteria.
            </p>
          </div>
          <div className="inner-Sec2">
            <h2>Our efforts</h2>
            <div className="row">
              <div className="col">
                <div className="col1Txt">
                  <h3 className="heading">Basic Information</h3>
                  <div>
                    <h4>Nature of Business</h4>
                    <p>Exporter and Manufacturer</p>
                    <h4>Additional Business</h4>
                    <ul>
                      <li>Distributor</li>
                      <li>Exporter</li>
                      <li>Wholesaler</li>
                      <li>Service Provider</li>
                    </ul>
                    <h4>Total Number of Employees</h4>
                    <p>11 to 25 People</p>
                    <h4>Year of Establishment</h4>
                    <p>1997</p>
                    <h4>Legal Status of Firm</h4>
                    <p>Individual - Proprietor</p>
                    <h4>Annual Turnover</h4>
                    <p>Rs. 1 - 2 Crore</p>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="col2Txt">
                  <h3 className="heading">Commitments</h3>
                  <p>
                    We support pledges and initiatives, such the American Bar
                    Association’s Pledge for Change: Disability Diversity in the
                    Legal Profession.
                  </p>
                </div>
                <div className="col2Txt">
                  <h3 className="heading">Company USP</h3>
                  <p>
                    Exprienced R & D Department, Good Financial Position & TQM,
                    Large product line , Large production Capatacity, Providing
                    Customized Solutions are the Primart Competative Avdantages
                    of our company. We don't have testing Facilities.
                  </p>
                </div>
              </div>
              <div className="col colthree">
                <div className="col3Txt">
                  <h3 className="heading">Statutory Profile</h3>
                  <p>
                    Our import and export code(ICE) code is 05130***** and our
                    Bankers are ICICI Bank, ICICI Bank, ICICI Bank, ICICI. Our
                    GST no. is 07Axyzxyz
                  </p>
                </div>
                <div className="col3Txt">
                  <h3 className="heading">Events</h3>
                  <p>
                    We host a variety of events to raise awareness of
                    differences across cultures, backgrounds, and experiences;
                    recognize and promote the value of diversity; and teach
                    inclusion.
                  </p>
                </div>
              </div>
            </div>

            <div className="icons">
              <div className="iconsTxt">Follow Creative Balloons</div>
              <a href="https://twitter.com">
                <svg
                  className="iconTwitter"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.48693 4.10523L4.11908 3.70164C3.96091 3.45389 3.67259 3.32137 3.38157 3.36266C3.09055 3.40396 2.85047 3.61145 2.76746 3.89342L3.48693 4.10523ZM2 18.5V17.75C1.66066 17.75 1.3636 17.9778 1.27564 18.3056C1.18767 18.6333 1.33072 18.9793 1.62446 19.1492L2 18.5ZM6.5 16.4705L7.10314 16.9163L7.48637 16.3978L7.03124 15.9411L6.5 16.4705ZM12.1209 8.98003L12.1692 9.72848L13.0682 9.67047L12.8482 8.79686L12.1209 8.98003ZM18.6458 5L18.1495 5.5623L18.4112 5.79326L18.7564 5.7418L18.6458 5ZM22 4.5L22.6682 4.84067C22.7957 4.59048 22.7728 4.28998 22.6088 4.06201C22.4448 3.83404 22.1672 3.71679 21.8894 3.7582L22 4.5ZM19.9922 8.43797L19.324 8.0973L19.2486 8.24519L19.2426 8.41108L19.9922 8.43797ZM8 19.25C5.92339 19.25 4.00824 18.7953 2.37554 17.8508L1.62446 19.1492C3.52184 20.2468 5.70516 20.75 8 20.75V19.25ZM2 19.25C3.67848 19.25 4.94726 18.6801 5.79524 18.1065C6.2178 17.8206 6.5367 17.5335 6.75294 17.3141C6.86126 17.2042 6.94445 17.1106 7.00264 17.0417C7.03175 17.0072 7.05467 16.9789 7.0714 16.9577C7.07976 16.9471 7.08659 16.9382 7.09188 16.9313C7.09452 16.9278 7.09678 16.9248 7.09866 16.9223C7.0996 16.9211 7.10044 16.92 7.10119 16.919C7.10156 16.9185 7.10191 16.918 7.10223 16.9175C7.1024 16.9173 7.10262 16.917 7.1027 16.9169C7.10292 16.9166 7.10314 16.9163 6.5 16.4705C5.89686 16.0248 5.89707 16.0245 5.89726 16.0242C5.89732 16.0241 5.89751 16.0239 5.89763 16.0237C5.89786 16.0234 5.89808 16.0231 5.89827 16.0229C5.89865 16.0223 5.89894 16.022 5.89914 16.0217C5.89956 16.0211 5.89962 16.0211 5.89933 16.0214C5.89876 16.0222 5.8968 16.0247 5.89345 16.029C5.88674 16.0375 5.8745 16.0527 5.85674 16.0738C5.82117 16.1159 5.76374 16.1809 5.68456 16.2612C5.5258 16.4223 5.2822 16.6426 4.95476 16.8641C4.30274 17.3051 3.32152 17.75 2 17.75V19.25ZM16 4.75C16.8248 4.75 17.5761 5.05623 18.1495 5.5623L19.1421 4.4377C18.3052 3.69904 17.2041 3.25 16 3.25V4.75ZM18.7564 5.7418L22.1106 5.2418L21.8894 3.7582L18.5352 4.2582L18.7564 5.7418ZM21.3318 4.15933L19.324 8.0973L20.6603 8.77865L22.6682 4.84067L21.3318 4.15933ZM19.2426 8.41108C19.0266 14.4336 14.0756 19.25 8 19.25V20.75C14.886 20.75 20.4968 15.2914 20.7417 8.46486L19.2426 8.41108ZM12.0726 8.23159C8.86676 8.43843 5.87888 6.45804 4.11908 3.70164L2.85478 4.50882C4.81846 7.58456 8.26892 9.98012 12.1692 9.72848L12.0726 8.23159ZM12.8482 8.79686C12.346 6.80295 13.9211 4.75 16 4.75V3.25C12.9341 3.25 10.6553 6.23173 11.3936 9.1632L12.8482 8.79686ZM7.03124 15.9411C4.13264 13.0325 3.04356 8.26697 4.2064 4.31703L2.76746 3.89342C1.45938 8.33672 2.65993 13.6797 5.96876 17L7.03124 15.9411Z"
                    fill="#141B34"
                  />
                </svg>
              </a>
              <a href="https://www.facebook.com/">
                <svg
                  className="iconFacebook"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clip-rule="evenodd"
                    d="M6.18182 10.3333C5.20406 10.3333 5 10.5252 5 11.4444V13.1111C5 14.0304 5.20406 14.2222 6.18182 14.2222H8.54545V20.8889C8.54545 21.8081 8.74951 22 9.72727 22H12.0909C13.0687 22 13.2727 21.8081 13.2727 20.8889V14.2222H15.9267C16.6683 14.2222 16.8594 14.0867 17.0631 13.4164L17.5696 11.7497C17.9185 10.6014 17.7035 10.3333 16.4332 10.3333H13.2727V7.55556C13.2727 6.94191 13.8018 6.44444 14.4545 6.44444H17.8182C18.7959 6.44444 19 6.25259 19 5.33333V3.11111C19 2.19185 18.7959 2 17.8182 2H14.4545C11.191 2 8.54545 4.48731 8.54545 7.55556V10.3333H6.18182Z"
                    stroke="#141B34"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
              <a href="https://www.linkedin.com/">
                <svg
                  className="iconLinkedin"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.5 9.5H2V22H6.5V9.5Z"
                    stroke="#141B34"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6.5 4.25C6.5 5.49264 5.49264 6.5 4.25 6.5C3.00736 6.5 2 5.49264 2 4.25C2 3.00736 3.00736 2 4.25 2C5.49264 2 6.5 3.00736 6.5 4.25Z"
                    stroke="#141B34"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.0001 9.5H9.5V22H14.0001V15.7502C14.0001 14.7837 14.7835 14.0002 15.75 14.0002C16.7165 14.0002 17.5 14.7837 17.5 15.7502V22H21.9987L22.0001 14.0002C22.0001 11.515 19.6364 9.50024 17.2968 9.50024C15.9649 9.50024 14.7767 10.1531 14.0001 11.174V9.5Z"
                    stroke="#141B34"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default AboutUs;
